import { useTranslation } from 'react-i18next';
import { PaAccountsPage } from '@features/user/payoutRequest';
import { useEffect, useState } from 'react';
import { getPaAccounts } from '@src/services/payout.ts';
import { PaAccounts } from '@src/types';

export const PayoutRequestPage = () => {
  const [paRequestData, setPaRequestData] = useState<PaAccounts[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const fetchPaAccounts = async () => {
    setIsLoading(true);

    const response = await getPaAccounts();

    setPaRequestData(response.data);

    setIsLoading(false);
  };

  useEffect(() => {
    fetchPaAccounts().then();
  }, []);

  return (
    <div className={'flex flex-col min-w-[900px] gap-y-6.5'}>
      <h1 className={'text-[23px] font-medium'}>
        {isLoading
          ? t('payoutRequest.loadingTitle')
          : paRequestData.length
          ? t('payoutRequest.title', { total: paRequestData.length })
          : t('payoutRequest.emptyTitle')}
      </h1>
      <PaAccountsPage data={paRequestData} isLoading={isLoading} />
    </div>
  );
};
